import React from "react";
import { Link } from "react-router-dom"; // Import the Link component
import Button from "../ResubleComp/Button";

const Banner = () => {
  const token =
    localStorage.getItem("EXPERT_AUTH_TOKEN") ||
    localStorage.getItem("USER_AUTH_TOKEN");

  return (
    <div className="lg:w-[95%] mt-20  m-5 mb-60 lg:mb-44 md:m-6 md:mt-4 flex flex-row lg:flex-row rounded-[20px]">
      <div className=" w-full lg:mt-16 flex flex-col lg:w-2/3 lg:pl-28 md:mx-10 lg:flex justify-center ">
        <h3 className="mb-5 font-bold text-5xl lg:text-6xl leading-tight text-center lg:text-left">
          Stay ahead with Instant solutions to your problems
        </h3>
        <p className="my-5 lg:text-xl text-2xl font-medium mb-8 text-center lg:text-left">
          Get instant solutions to science, technology, engineering and
          mathematics problems via live one-to-one and MagicAI.
        </p>

        <div className="flex justify-center lg:justify-start  mt-12">
          <Link to="/usersignup">
            <Button
              className={`bg-gradient-to-r from-sky-400 to-indigo-600 h-12 text-white text-sm font-semibold px-6 rounded-lg hover:from-indigo-600 hover:to-sky-400 transition-colors duration-300 hover:text-gray-100 ${
                token ? "cursor-not-allowed " : ""
              }`}
              disabled={token}
            >
              Join Now
            </Button>
          </Link>
        </div>
      </div>
      {/* Center the image on larger screens (lg) */}
      <div className="w-full lg:w-1/2 lg:flex items-center justify-center hidden md:flex ">
        <img
          src="/images/study3.png"
          alt="banner"
          className="w-3/4 md:w-1/2 lg:w-1/2 mt-14"
        />
      </div>
    </div>
  );
};

export default Banner;
